import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "avatar-form" }
const _hoisted_2 = {
  key: 0,
  class: "notification errors-notification is-danger"
}
const _hoisted_3 = { class: "field" }
const _hoisted_4 = {
  key: 0,
  class: "user-avatar"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "field" }
const _hoisted_7 = ["disabled"]

import { ref, onMounted } from "vue";
import FileSelect from "./fields/file-select.vue";
import VglistUtils from "../utils";
import { DirectUpload } from "@rails/activestorage";
import Turbolinks from "turbolinks";

type UserPayload = {
  user: {
    avatar?: string;
  };
};

interface Props {
  railsDirectUploadsPath: string;
  submitPath: string;
  deletePath: string;
  avatarPath?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'avatar-input',
  props: {
    railsDirectUploadsPath: {},
    submitPath: {},
    deletePath: {},
    avatarPath: {}
  },
  setup(__props: any) {

const props = __props;

const avatar = ref<File | undefined>(undefined);
const avatarBlob = ref<string | undefined>(undefined);
// If there's an avatar path prop, set the existingAvatar to it.
const existingAvatar = ref<string | undefined>(props.avatarPath);
const hasSelectedFile = ref(false);
const errors = ref<string[]>([]);

function onChange(file: File) {
  uploadFile(file);
  hasSelectedFile.value = true;
}

function uploadFile(file: File) {
  existingAvatar.value = undefined;
  const url = props.railsDirectUploadsPath;
  const upload = new DirectUpload(file, url, {
    directUploadWillStoreFileWithXHR: (xhr) => {
      // Use this workaround to make sure that Direct Upload-ed images are
      // uploaded with the correct header. Otherwise they will end up being
      // private files.
      xhr.setRequestHeader("x-amz-acl", "public-read");
    }
  });

  upload.create((error, blob) => {
    if (error) {
      // TODO: Handle this error.
      console.log(error);
    } else if (blob) {
      avatarBlob.value = blob.signed_id;
    }
  });
}

function onSubmit() {
  const submittableData: UserPayload = { user: {} };
  if (avatarBlob.value) {
    submittableData.user.avatar = avatarBlob.value;
  }

  VglistUtils.authenticatedFetch(props.submitPath, "PUT", JSON.stringify(submittableData))
    .then(() => {
      Turbolinks.visit(`${window.location.origin}/settings`);
    })
    .catch((errorsResp) => {
      errors.value = errorsResp;
      const submitButton = document.querySelector(".js-submit-button");
      if (submitButton) {
        submitButton.classList.add("js-submit-button-error");
        setTimeout(() => {
          submitButton.classList.remove("js-submit-button-error");
        }, 2000);
      }
    });
}

// TODO: Add a confirmation dialog before deleting.
function onDelete() {
  VglistUtils.authenticatedFetch(props.deletePath, "DELETE")
    .then(() => {
      Turbolinks.visit(`${window.location.origin}/settings`);
    })
    .catch((errorsResp) => {
      errors.value = errorsResp;
    });
}

// Reload the page on cancel.
function onCancel() {
  Turbolinks.visit(`${window.location.origin}/settings`);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (errors.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(errors.value.length > 1 ? "Errors" : "An error") + " prevented your avatar from being saved:", 1),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error) => {
              return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _cache[1] || (_cache[1] = _createElementVNode("label", { class: "label" }, "Avatar", -1)),
      (existingAvatar.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("img", {
              src: existingAvatar.value,
              width: "150px",
              height: "150px"
            }, null, 8, _hoisted_5)
          ]))
        : _createCommentVNode("", true),
      _createVNode(FileSelect, {
        modelValue: avatar.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((avatar).value = $event)),
          onChange
        ],
        fileClass: 'user-avatar'
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "button is-primary mr-10 mr-0-mobile is-fullwidth-mobile js-submit-button",
        value: "Submit",
        onClick: _withModifiers(onSubmit, ["prevent"]),
        disabled: !hasSelectedFile.value
      }, " Submit ", 8, _hoisted_7),
      (hasSelectedFile.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "button mr-10 mr-0-mobile is-fullwidth-mobile",
            value: "Cancel",
            onClick: _withModifiers(onCancel, ["prevent"])
          }, " Cancel "))
        : _createCommentVNode("", true),
      (__props.avatarPath && !hasSelectedFile.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "button is-danger mr-10 mr-0-mobile is-fullwidth-mobile",
            value: "Remove avatar",
            onClick: _withModifiers(onDelete, ["prevent"])
          }, " Remove avatar "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})